define('v3/Common/Services/abilityGrowthService',['v3/Common/Services/Backend/abilityGrowthBackend'], function (backend) {
	var none = { name: 'none', css: 'no-growth', value: 0 };
	var equal = { name: 'GrowthAverage', css: 'growth-average', value: 3 };
	var farBetter = { name: 'GrowthFarAboveAverage', css: 'growth-far-above-average', value: 5 };
	var better = { name: 'GrowthAboveAverage', css: 'growth-above-average', value: 4 };
	var farWorse = { name: 'GrowthFarBelowAverage', css: 'growth-far-below-average', value: 1 };
	var worse = { name: 'GrowthBelowAverage', css: 'growth-below-average', value: 2 };

	var getBoundaryValue = function (value, factor) {
		return value + factor * Math.abs(value);
	};

	return {
		getUserAbilityGrowthBySubjectGroup: function (pupilId, subjectGroupId, period, usePupilAverageGrowth) {
			return backend.getUserAbilityGrowthBySubjectGroup(pupilId, subjectGroupId, period, usePupilAverageGrowth)
				.then(function (data) {
					if (!data) {
						if (usePupilAverageGrowth) {
							return { score: 0 };
						} else {
							return { abilityGrowth: null, targetAbilityGrowth: null };
						}
					}

					/* var maxValue = Math.max(1, data.abilityGrowth, data.targetAbilityGrowth);
					data.abilityGrowthPercent = data.abilityGrowth < 0 ? 0 : Math.round(data.abilityGrowth * 100 / maxValue);
					data.targetAbilityGrowthPercent = data.targetAbilityGrowth < 0 ? 0 : Math.round(data.targetAbilityGrowth * 100 / maxValue); */

					return data;
				});
		},
		getGrowthClass: function (actualGrowth, expectedGrowth) {
			if (actualGrowth === null || expectedGrowth === null) { return none; }
			if ((expectedGrowth - 10) <= actualGrowth && actualGrowth <= (expectedGrowth + 10)) { return equal; }
			if (actualGrowth >= getBoundaryValue(expectedGrowth, +0.2)) { return farBetter; }
			if (actualGrowth >= getBoundaryValue(expectedGrowth, +0.1)) { return better; }
			if (actualGrowth <= getBoundaryValue(expectedGrowth, -0.2)) { return farWorse; }
			if (actualGrowth <= getBoundaryValue(expectedGrowth, -0.1)) { return worse; }
			return equal;
		},
		scores: {
			none: none,
			equal: equal,
			farBetter: farBetter,
			better: better,
			farWorse: farWorse,
			worse: worse
		}
	};
});

